






export default {
  name: "CurrencyFormat",
  props: {
    price: {
      type: Number,
      required: true
    },
    noDecimal: {
      type: Number,
      default: 2
    }
  },
  computed: {
    GetCurrenyClass() {
      var decimals = this.noDecimal;
      var defaultclass = "currency";

      if (decimals > 5) {
        decimals = 5;
      }

      switch (decimals) {
        case 0:
          defaultclass = "currency0";
          break;
        case 1:
          defaultclass = "currency1";
          break;
        case 2:
          defaultclass = "currency2";
          break;
        case 3:
          defaultclass = "currency3";
          break;
        case 4:
          defaultclass = "currency4";
          break;
        case 5:
          defaultclass = "currency5";
          break;
        default:
          defaultclass = "currency";
          break;
      }

      return defaultclass;
    }
  },
  data() {
    return {};
  }
};
